var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-no-data fb fb-col fb-cross-center fb-main-center"},[_c('div',{staticClass:"item-flex-1"}),_vm._t("default"),(_vm.content)?_c('p',{staticClass:"pb-24 font-28 no-text"},[_vm._v(_vm._s(_vm.content))]):_vm._e(),_c('div',{staticClass:"item-flex-2"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }